module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAoElEQVQokZXQwUnEABBG4S+DaBG2sGDWg1qD2oC5ednN0XJMBWlAsYlFzJIWUoKH6MWDE1hBNHnwX2beDMwURf0iOUaNO6yy1qPFIz7gKBuneELpJ1eZe9xiiNz8m3xIiWecBLb/yBNn2ASqGfJEFThfMLCOBTJ8Bl4XDPTh+89zaQMNuhnyHk1gxA3e/pA7XGOcjh5wiQfs8J7ZZe0iHV9Ujh3V6kN18QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/about/椭圆.png
// module id = qm+u
// module chunks = 1